// // import { SearchBar, Button, WhiteSpace, WingBlank } from "antd-mobile";
// import React from "react";
// import { Header } from "./Introduce";
// import test_know_style from "../css/test_know_style.css";
// import { Toast } from "antd-mobile";
// import { request } from "../request";

// class TestKnow extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       active: 1,
//       data: [],
//     };
//   }

//   componentDidMount() {
//     request("index/getDataFile", { type: "送样须知" }, ({ data }) => {
//       if (data.code === 1) {
//         console.log(data.data[0]["files"]);
//         this.setState({
//           data: data.data[0]["files"],
//         });
//       } else {
//         Toast.fail("获取设备失败");
//       }
//     });
//   }

//   render() {
//     return (
//       <div>
//         <Header text="送检须知"></Header>

//         <div className={test_know_style.list}>
//           {this.state.data.map((item, index) => (
//             <a
//               href={"#/testDetail/" + item.id}
//               className={test_know_style.item}
//               key={index}
//             >
//               <span>{item.file_name}</span>
//               <i
//                 className="iconfont icon-you"
//                 style={{ color: "#666666", fontSize: "14px" }}
//               ></i>
//             </a>
//           ))}
//         </div>
//       </div>
//     );
//   }
// }

// export default TestKnow;

import React from "react";
import styles from "../css/Download.css";
import { Header } from "./Introduce";
import { Toast } from "antd-mobile";
import { request } from "../request";

const Item = ({ file }) => {
  return (
    <a
      // href={"http://liangql.tsinghua.site/" + file.path_file}
      href={"#/testDetail/" + file.id}
      className={styles.item}
    >
      <div className={styles.fileName}>{file.file_name}</div>
      <i
        className="iconfont icon-you"
        style={{ color: "#666666", fontSize: "14px" }}
      ></i>
    </a>
  );
};

class App extends React.Component {
  state = {
    data: [{ files: [] }],
  };

  componentDidMount() {
    request("index/getDataFile", { type: "送样须知" }, ({ data }) => {
      if (data.code === 1) {
        console.log(data.data, "data.data");
        this.setState({
          data: data.data,
        });
      } else {
        Toast.fail("获取设备失败");
      }
    });
  }

  render() {
    return (
      <div style={{ backgroundColor: "white", paddingBottom: "20px" }}>
        <Header text="送样须知"></Header>
        {this.state.data.map((item, index) => (
          <div className={styles.main}>
            <p className={styles.title} style={{ display: "none" }}>
              {item.type_name}
            </p>
            {item.files.map((item) => (
              <Item file={item}></Item>
            ))}
          </div>
        ))}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/test_know.js